
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import SEOHelmet from "@/components/SEOHelmet";

const Book = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 to-secondary/5 py-8 px-4">
      <SEOHelmet
        title="Book Your Consultation - Organize by Design"
        description="Schedule your free home organization consultation with Organize by Design. Get a custom quote for your Michigan home organization project."
        canonicalUrl="https://organizebydesignmichigan.com/book"
      />

      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Book Your Consultation
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Choose a time that works best for you. We serve all of Southwest
            Michigan — Buchanan, Niles, St. Joseph, Benton Harbor, and more.
          </p>
        </div>

        {/* ZenMaid Booking Form */}
        <div className="bg-card rounded-xl shadow-lg overflow-hidden min-h-[500px]">
          <iframe
            sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation"
            height="4000"
            src="https://app.zenmaid.com/booking-forms/TSF7L/book"
            frameBorder="0"
            scrolling="no"
            style={{ width: '100%' }}
            title="Book a consultation with Organize by Design"
          />
        </div>

        {/* Fallback CTA */}
        <div className="text-center mt-8 space-y-3">
          <p className="text-sm text-muted-foreground">
            Prefer to book by phone? Give us a call — we'd love to hear from
            you.
          </p>
          <Button
            size="lg"
            variant="outline"
            onClick={() => window.open("tel:+16167270343")}
          >
            <Phone className="w-5 h-5 mr-2" />
            (616) 727-0343
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Book;
